import { ORDER_METHODS, PaymentMethods } from '../../../../../../services/exports/Constants';

export default {
  title: 'Métodos de pagamento',
  fields: {
    hidden_payment_methods: {
      label: 'Métodos de pagamento ocultos',
    },
    has_online_payments: {
      label: 'Tem pagamentos online',
    },
    has_paypal_upcharge: {
      label: 'Acréscimo de 3,5% extra em transações PayPal',
    },
    has_cash_payments: {
      label: 'Tem pagamentos em dinheiro',
    },
    has_occ_cash_payments: {
      label: 'Pagamentos em dinheiro no Call Center ativados',
    },
    has_in_store_card_payments: {
      label: 'Tem pagamentos por cartão na loja',
    },
    overwrite_cash_payments_to_invoice: {
      label: 'Designar pagamentos em dinheiro como «Fatura»',
    },
  },
  payment_methods: {
    [PaymentMethods.CARD]: 'Cartão',
    [PaymentMethods.PAYPAL]: 'PayPal',
    [PaymentMethods.APPLE_PAY]: 'Apple Pay',
    [PaymentMethods.GOOGLE_PAY]: 'GPay',
    [PaymentMethods.SOFORT]: 'Sofort',
    [PaymentMethods.IDEAL]: 'iDEAL | Wero',
    [PaymentMethods.BANCONTACT]: 'Bancontact',
    [PaymentMethods.EPS]: 'EPS',
    [PaymentMethods.P24]: 'Przelewy24',
    [PaymentMethods.BLIK]: 'BLIK',
    [PaymentMethods.TWINT]: 'TWINT',
    [PaymentMethods.VENMO]: 'Venmo',
    [PaymentMethods.WERO]: 'Wero',
    [PaymentMethods.KLARNA]: 'Klarna',
    [PaymentMethods.TRUSTLY]: 'Trustly',
    [PaymentMethods.PIX]: 'Pix',
    [PaymentMethods.NUPAY]: 'NuPay',
    [PaymentMethods.GIROPAY]: 'Giropay',
    [PaymentMethods.SEPA_DEBIT]: 'Débito SEPA',
    [PaymentMethods.CASH]: 'Dinheiro',
    [PaymentMethods.BACS_DEBIT]: 'Débito Bacs',
    [PaymentMethods.PAY_BY_BANK]: 'Pagar por banco',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Recolha',
    [ORDER_METHODS.delivery]: 'Entrega',
    [ORDER_METHODS.on_site]: 'Pedidos à mesa',
  },
  modals: {
    confirmation: {
      title: 'Tem a certeza?',
      description:
        'Após confirmar, os pagamentos online ficarão <strong>{{onlineState}}</strong>, os pagamentos em dinheiro ficarão <strong>{{cashState}}</strong>',
    },
  },
  labels: {
    off: 'desativado',
    on: 'ativado',
  },
  buttons: {
    save: 'Guardar',
    configure_online_payments: 'Configurar pagamentos online',
  },
  toasts: {
    failed_to_save_changes: 'Falha ao guardar alterações',
    changes_got_saved: 'Alterações guardadas',
  },
};
